import {
  ICreateCompanyReq,
  ICompany,
  IUpdateGoogleAds
} from "../../models/company/index";
import {
  IBasePagingRes,
  IBaseResponse,
  IBaseResponseModel
} from "../../models/common/models.type";
import api from "../remote/baseApi";
import ApiEndpoints from "../remote/apiEndpoints";
import { envConfig } from "../../config/env.config";
import { IPayroll } from "@/models/payroll";
import { IGetUsersReq } from "@/models/user";
import { IOpenAi, IOpenAiDocx, IOpenAiFile } from "@/models/openai";

const API = ApiEndpoints.OpenAI;
const baseURL = envConfig.API_ENDPOINT;

const getAll = (): Promise<IBaseResponseModel<IOpenAiDocx>> => {
  return api.get(baseURL, API.GETALL.url);
};

const uploadfile = (params: IOpenAi): Promise<IBaseResponseModel<string>> => {
  return api.post(baseURL, API.UPLOADFILE.url, params);
};

const create = (params: IOpenAi): Promise<IBaseResponseModel<string>> => {
  return api.post(baseURL, API.CREATE.url, params);
};

const createChatTaskAnalytics = (
  params: IOpenAi
): Promise<IBaseResponseModel<string>> => {
  return api.post(baseURL, API.CreateChatTaskAnalytics.url, params);
};

const deletefile = (id: string): Promise<IBaseResponseModel<string>> => {
  return api.delete(baseURL, API.DELETE.url + "?id=" + id);
};

const translateOfficeFile = (
  filePath: string,
  fileName: string
): Promise<IBaseResponseModel<string>> => {
  return api.get(
    baseURL,
    API.TranslateOfficeFile.url +
      "?filePath=" +
      filePath +
      "&fileName=" +
      fileName,
    {
      timeout: 300000
    }
  );
};

const OpenAiService = {
  getAll,
  create,
  createChatTaskAnalytics,
  uploadfile,
  deletefile,
  translateOfficeFile
};

export default OpenAiService;
